import React, { useState } from 'react';
import { TextField, Button, Container, Typography, CircularProgress, Box, Alert, Snackbar, InputAdornment, IconButton, FormControl, OutlinedInput, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const LoginForm = ({ onLogin, loader, snackbar, setSnackbar }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false)


  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const handleLogin = async () => {
    const success = await onLogin(email, password);
    if (success) {
      navigate('/home');
    }
  };

  const handleClose = () => {
    setSnackbar({ open: false, message: "", severity: "" });
  };

  return (
    <Box className="login_wrapper">
      <Header isLogin={true} />
      <Container maxWidth="sm" className="login_form_container">
        <Typography variant="h4" gutterBottom>Login</Typography>
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
       <FormControl fullWidth>
        <InputLabel htmlFor="input-label-password">Password</InputLabel>
       <OutlinedInput
          label="Password"
          variant="outlined"
          id="input-label-password"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
       </FormControl>
        <Button variant="contained" color="primary" fullWidth onClick={handleLogin}>
          {loader ? <CircularProgress /> : "Login"}
        </Button>
        <Snackbar open={snackbar?.open} autoHideDuration={5000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity={snackbar?.severity}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {snackbar?.message}
          </Alert>
        </Snackbar>
      </Container>
      <Footer />
    </Box>
  );
};

export default LoginForm;
